// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DocumentFormController from "./document_form_controller"
application.register("document-form", DocumentFormController)

import DocumentItemFormController from "./document_item_form_controller"
application.register("document-item-form", DocumentItemFormController)

import DocumentPaymentFormController from "./document_payment_form_controller"
application.register("document-payment-form", DocumentPaymentFormController)

import EntitiesFormController from "./entities_form_controller"
application.register("entities-form", EntitiesFormController)

import GeneralController from "./general_controller"
application.register("general", GeneralController)

import HelpTicketFormController from "./help_ticket_form_controller"
application.register("help-ticket-form", HelpTicketFormController)
